/**
 * mutations
 *
 * @Author  Carey.zhou
 * @DATE    create on 2019/9/16
 * @DESC
 */
import * as types from './types'

export const mutations = {

  /**
   * 设置查询参数
   * @param state
   * @param queryParam
   */
  [types.SET_QUERY_PARAM]: (state, queryParam) => {
    const { startDate, endDate } = state.queryParam
    if (queryParam.vno!== undefined) {
      state.queryParam.vno = queryParam.vno
    }
    state.queryParam.startDate = queryParam.startDate ? queryParam.startDate : startDate
    state.queryParam.endDate = queryParam.endDate || queryParam.endDate === '' ? queryParam.endDate : endDate
  },

  [types.CLEAR_QUERY_PARA]: (state) => {
    state.queryParam.vno = ''
    state.queryParam.startDate = ''
    state.queryParam.endDate = ''
  }
}
